import React from 'react'
import "./FooterStyles.css"
import { FaFacebook, FaHome, FaInstagram, FaLinkedin, FaMailBulk, FaPhone, FaTwitter } from 'react-icons/fa'


const Footer = () => {
  return (
    <div className='footer'>
        <div className='footer-container'>
            <div className='left'>
                <div className='location'>
                    <FaHome size={20} style={{color: "var(--nudo-text)", marginRight: "2rem"}}/>
                    <div>
                        <p>Villa María</p>
                        <p>Cordoba</p>
                        <p>Argentina</p>
                    </div>
                </div>
                <div className='phone'>
                    <h4><FaPhone size={20} style={{color: "var(--nudo-text)", marginRight: "1rem"}}/> +54 9 353 4173516</h4>
                </div>	
                <div className='email'>
                <h4><FaMailBulk size={20} style={{color: "var(--nudo-text)", marginRight: "1rem"}}/> desarrollador@joagalqui.com</h4>
                </div>
            </div>
            <div className='right'>
                <h4>Nudo Lab</h4>
                <p>Tu proyecto, mi proyecto.</p>
                <div className='social'>
                    <a href='https://www.facebook.com/joako.quiroga.92/?viewas=&should_open_composer=false&show_switched_toast=false&show_invite_to_follow=false&show_switched_tooltip=false&show_podcast_settings=false&show_community_review_changes=false&show_community_rollback=false&show_follower_visibility_disclosure=false&bypass_exit_warning=true'>
                        <FaFacebook size={20} style={{color: "var(--nudo-text)", marginRight: "1rem"}} />
                    </a>
                    <a href='https://www.instagram.com/joaco.gq/?hl=es-la'>
                        <FaInstagram size={20} style={{color: "var(--nudo-text)", marginRight: "1rem"}} />
                    </a>
                    <a href='https://x.com/JoakoXXV'>
                        <FaTwitter size={20} style={{color: "var(--nudo-text)", marginRight: "1rem"}} />
                    </a>
                    <a href='https://www.linkedin.com/in/joaquingallardoquiroga/'>
                        <FaLinkedin size={20} style={{color: "var(--nudo-text)", marginRight: "1rem"}} />
                    </a>
                </div>
            </div>
        </div>
    </div>

  )

}

export default Footer